"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SentenceSplitter = void 0;
class SentenceSplitter {
    static { this.BOUNDARY_PATTERN = /(?<=[.!?])\s+(?=[A-Z(])/; }
    static split(text) {
        return text
            .split(SentenceSplitter.BOUNDARY_PATTERN)
            .map((sentence) => sentence.trim())
            .filter((sentence) => sentence !== '');
    }
}
exports.SentenceSplitter = SentenceSplitter;
//# sourceMappingURL=sentence-splitter.js.map